export const cardsList = {
    filterByAuthorized: false,
    show: {
        /** Display alias of the bank card in cards list */
        alias: false,
        /** Display localized product name of card depending on Client-Accept-Language header field */
        cardType: true,
        expiryDate: true,
        /** Display insurance policy agreed for particular bank card */
        insurance: false,
        /** Display masked card number, only the first 6 and the last 4 digits are displayed, asterisk is used for the rest of digits */
        number: true,
        owner: true,
        /** Display AT specific field sbDeckelungsLimits.maximumIndoorWithdrawalLimit */
        withdrawalLimit: false,
    },
};
